<template>
  <div>
    <main role="main">
      <div class="container">
        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="false"
        ></loading>

        <div class="row">
          <div class="col-md-12">
            <h2 class="mb-3">
              <i class="fa fa-search"></i> {{ $t("text.auditLog.auditLogSearch") }}
              <router-link
                  :to="{ name: 'AuditLogExternal' }"
                  class="btn btn-primary text-white float-right"
              >
                {{
                  $t("text.auditLog.internalAuditLog.linkToExternalAuditLog")
                }}
              </router-link
              >
            </h2>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card mb-3 form-condensed">
              <div class="card-body bg-light">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="dateFrom">{{
                          $t("text.auditLog.dateFrom")
                        }}</label>

                      <VueCtkDateTimePicker
                          id="dateFrom"
                          format="YYYY-MM-DD HH:mm:ss"
                          :range="false"
                          :no-label="true"
                          :auto-close="false"
                          formatted="DD.MM.YYYY, HH:mm"
                          v-model="dateFrom"
                          :only-date="false"
                          :custom-shortcuts="customShortcuts"
                          :locale="$t('text.globals.datePickerLocale')"
                          :button-now-translation="$t('text.globals.now')"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="dateFrom">{{
                          $t("text.auditLog.dateTo")
                        }}</label>

                      <VueCtkDateTimePicker
                          id="dateTo"
                          format="YYYY-MM-DD HH:mm:ss"
                          :range="false"
                          :no-label="true"
                          :auto-close="false"
                          formatted="DD.MM.YYYY HH:mm:ss"
                          v-model="dateTo"
                          :only-date="false"
                          :custom-shortcuts="customShortcuts"
                          :locale="$t('text.globals.datePickerLocale')"
                          :button-now-translation="$t('text.globals.now')"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="uuid">{{
                          $t("text.metadata.id")
                        }}</label>

                      <input
                          type="text"
                          class="form-control"
                          id="uuid"
                          v-model="uuid"
                          :placeholder="$t('text.auditLog.enterValue')"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="opravilna_stevilka_zadeve">{{
                          $t("text.globals.caseNumber")
                        }}</label>

                      <input
                          type="text"
                          class="form-control"
                          id="opravilna_stevilka_zadeve"
                          v-model="opravilna_stevilka_zadeve"
                          :placeholder="$t('text.auditLog.enterValue')"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="ehrambaUporabnik">{{
                          $t("text.auditLog.internalAuditLog.eHrambaUser")
                        }}</label>

                      <input
                          type="text"
                          class="form-control"
                          id="ehrambaUporabnik"
                          v-model="ehrambaUporabnik"
                          :placeholder="$t('text.auditLog.enterValue')"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="uporabnik">{{
                          $t("text.auditLog.user")
                        }}</label>

                      <input
                          type="text"
                          class="form-control"
                          id="uporabnik"
                          v-model="uporabnik"
                          :placeholder="$t('text.auditLog.enterValue')"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="sodisce">{{
                          $t("text.globals.court")
                        }}</label>

                      <v-select
                          :options="filterOptions"
                          v-if="filterOptions.length > 0"
                          :reduce="(item) => item.id"
                          id="sodisce"
                          label="description"
                          class="form-control"
                          v-model="sodisce"
                      >
                        <span slot="no-options">{{
                            $t("text.globals.noOptions")
                          }}</span>
                      </v-select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="limit">{{
                          $t("text.auditLog.internalAuditLog.entryLimitSelect")
                        }}</label>

                      <v-select
                          :options="['50', '100', '500']"
                          id="limit"
                          class="form-control"
                          v-model="limit"
                      >
                        <span slot="no-options">{{
                            $t("text.globals.noOptions")
                          }}</span>
                      </v-select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="tip">{{
                          $t("text.auditLog.internalAuditLog.type")
                        }}</label>

                      <v-select
                          :options="typeOptions"
                          :reduce="(item) => item.key"
                          id="tip"
                          label="value"
                          class="form-control"
                          v-model="tip"
                      >
                        <span slot="no-options">{{
                            $t("text.globals.noOptions")
                          }}</span>
                      </v-select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="dogodek">{{
                          $t("text.auditLog.internalAuditLog.event")
                        }}</label>

                      <v-select
                          :options="eventOptions"
                          :reduce="(item) => item.key"
                          id="dogodek"
                          label="value"
                          class="form-control"
                          v-model="dogodek"
                      >
                        <span slot="no-options">{{
                            $t("text.globals.noOptions")
                          }}</span>
                      </v-select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="koncniUporabnikCert">{{
                          $t("text.metadata.certNum")
                        }}</label>

                      <input
                          type="text"
                          class="form-control"
                          id="koncniUporabnikCert"
                          v-model="koncniUporabnikCert"
                          :placeholder="$t('text.auditLog.enterValue')"
                      />
                    </div>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-12 text-right">
                    <a
                        id="transferredAuditLogSearchBtn"
                        v-if="$globalFunctions.checkForPermission('ISCI_REVIZ_SLED')"
                        class="btn btn-primary text-white"
                        @click="search_eHrambaLog(false)"
                    ><i class="fa fa-search"></i> {{ $t("text.globals.search") }} ({{ $t("text.globals.archive") }})</a
                    >

                    <a
                        id="auditLogSearchBtn"
                        v-if="$globalFunctions.checkForPermission('ISCI_REVIZ_SLED')"
                        class="btn btn-warning text-white ml-3"
                        @click="search_eHrambaLog(true)"
                    ><i class="fa fa-search"></i> {{ $t("text.globals.search") }}</a
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">
<!--              <div-->
<!--                  class="alert alert-info"-->
<!--                  v-if="-->
<!--                  entries_eHrambaLog.length === 0 &&-->
<!--                    entries_RM.length === 0 &&-->
<!--                    entries_CMISchangeLog.length == 0 &&-->
<!--                    searchDone">-->
<!--                <h5 class="pt-2">-->
<!--                  <em>{{-->
<!--                      $t("text.auditLog.internalAuditLog.noResultsWithFilters")-->
<!--                    }}</em>-->
<!--                </h5>-->
<!--              </div>-->

              <div
                  class="alert alert-info"
                  v-if="searchDone">
                <h5 class="pt-2">
                  <em>{{ $t("text.auditLog.internalAuditLog.latestTransferTime") }}:
                    {{ moment(auditLogTransferTime).local().format('DD. MM. YYYY @HH:mm:ss') }}</em>
                </h5>
              </div>

              <b-tabs
                  class="mt-5"
                  content-class="mt-3">
                <b-tab active>
                  <template #title>
                    <b-spinner type="border" small v-if="allLogsIsLoading"></b-spinner> {{$t('text.auditLog.internalAuditLog.combinedView') + ' (' + entries_All.length + ')'}}
                  </template>

                  <AuditLogTable :entries="entries_All" :section="'Grouped'"></AuditLogTable>
                </b-tab>
                <b-tab

                >
                  <template #title>
                    <b-spinner type="border" small v-if="eHrambaLogIsLoading"></b-spinner>
                    <b-spinner
                        small
                        v-if="eHrambaLogTimeout"
                        :variant="'warning'"
                        type="grow"></b-spinner> {{$t('text.auditLog.internalAuditLog.eHrambaLog')}} <span v-if="!eHrambaLogTimeout">({{entries_eHrambaLog.length}})</span>
                  </template>

                  <AuditLogTable :entries="entries_eHrambaLog" :section="'archeia'" :timeOut="eHrambaLogTimeout"
                                 :searchUrlParams="searchUrlParams"
                                 :useOldApiEndpoint="useOldApiEndpoint"
                                 :postData="getPostData()"></AuditLogTable>
                </b-tab>
                <b-tab>
                  <template #title>
                    <b-spinner type="border" small v-if="rmLogIsLoading"></b-spinner>
                    <b-spinner
                        small
                        v-if="rmLogTimeout"
                        :variant="'warning'"
                        type="grow"></b-spinner> {{$t('text.auditLog.internalAuditLog.recordsManagement') }} <span v-if="!rmLogTimeout">({{entries_RM.length}})</span>
                  </template>

                  <AuditLogTable :entries="entries_RM" :section="'RM'" :timeOut="rmLogTimeout"
                                 :searchUrlParams="searchUrlParams"
                                 :useOldApiEndpoint="useOldApiEndpoint"
                                 :postData="getPostData()"></AuditLogTable>
                </b-tab>
                <b-tab>
                  <template #title>
                    <b-spinner type="border" small v-if="CMISchangeLogIsLoading"></b-spinner>
                    <b-spinner
                        small
                        v-if="CMISchangeLogTimeout"
                        :variant="'warning'"
                        type="grow"></b-spinner> {{$t('text.auditLog.internalAuditLog.cmisLog')}} <span v-if="!CMISchangeLogTimeout">({{entries_CMISchangeLog.length}})</span>
                  </template>

                  <AuditLogTable :entries="entries_CMISchangeLog" :section="'CMISChangeLog'" :timeOut="CMISchangeLogTimeout"
                                 :searchUrlParams="searchUrlParams"
                                 :useOldApiEndpoint="useOldApiEndpoint"
                                 :postData="getPostData()"></AuditLogTable>
                </b-tab>

                <b-tab
                    v-if="!useOldApiEndpoint">
                  <template #title>
                    <b-spinner type="border" small v-if="eHrambaLogOldIsLoading"></b-spinner>
                    <b-spinner
                        small
                        v-if="eHrambaLogOldTimeout"
                      :variant="'warning'"
                      type="grow"></b-spinner> {{$t('text.auditLog.internalAuditLog.ehrambaLogOld')}} <span v-if="!eHrambaLogOldTimeout">({{entries_eHrambaLogOld.length}})</span>
                  </template>

                  <AuditLogTable :entries="entries_eHrambaLogOld" :section="'ehramba'" :timeOut="eHrambaLogOldTimeout"
                                 :searchUrlParams="searchUrlParams"
                                 :useOldApiEndpoint="useOldApiEndpoint"
                                 :postData="getPostData()"></AuditLogTable>
                </b-tab>

              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script type="text/javascript">
import Vue from "vue";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import $ from "jquery";
import AuditLogTable from "../components/AuditLogTable";
import swal from "sweetalert2";

export default {
  name: "AuditLog",
  components: {
    Loading,
    vSelect,
    AuditLogTable,
  },

  data() {
    return {
      uuid: this.$route.params.uuid ? this.$route.params.uuid : null,
      opravilna_stevilka_zadeve: null,
      sodisce: null,
      ehrambaUporabnik: null,
      uporabnik: null,
      tip: null,
      dogodek: null,
      koncniUporabnikCert: null,
      filterOptions: [],
      typeOptions: [],
      eventOptions: [],
      page: 0,
      limit: 500,
      isLoading: false,
      dateFrom: null,
      dateTo: null,
      selectedItemIndex: null,
      entries_RM: [],
      entries_eHrambaLog: [],
      entries_CMISchangeLog: [],
      entries_eHrambaLogOld: [],
      entries_All: [],
      customShortcuts: this.$t("text.globals.customDatePickerShortcuts"),
      allMetadataOptions: [],
      searchDone: false,
      searchUrlParams: null,
      auditLogTransferTime: null,
      useOldApiEndpoint: null,
      allLogsIsLoading: false,
      eHrambaLogIsLoading: false,
      rmLogIsLoading: false,
      CMISchangeLogIsLoading: false,
      eHrambaLogOldIsLoading: false,

      eHrambaLogTimeout: false,
      rmLogTimeout: false,
      CMISchangeLogTimeout: false,
      eHrambaLogOldTimeout: false,
    };
  },

  computed: {},

  mounted() {
    const _this = this;

    let p1 = _this.$store.dispatch("retrieveAllMetadataOptions");

    Promise.all([p1]).then((values) => {
      _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;

      _.each(_this.allMetadataOptions, function (val, key) {
        let property = val.property;

        if (property === "EH:sodisce") {
          _this.filterOptions = val.body;
        }
      });

      _this.retrieveTypeOptions();
      _this.retrieveEventOptions();
    });
  },

  methods: {
    async getLogTimeData() {
      const _this = this;

      axios
          .get(config.audit + "status")
          .then((res) => {
            _this.auditLogTransferTime = res.data.newestEntryDate;
            console.log("res.data", res.data);
          })
          .catch((error) => {
            console.error(error);
          });
    },

    async search_eHrambaLog(useOldApiEndpoint) {
      const _this = this;
      _this.searchDone = false;
      _this.useOldApiEndpoint = useOldApiEndpoint;

      if (!useOldApiEndpoint && (!_this.dateFrom || !_this.dateTo)) {
        swal.fire({
          title: _this.$t('text.auditLog.filterDataMissing'),
          icon: 'error',
          type: 'error',
          html: _this.$t('text.auditLog.datesRequired'),
          dangerMode: true,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: _this.$t('text.globals.close'),
        })
            .then((value) => {
            });

        return false;
      }

      // _this.isLoading = true;
      _this.entries_RM = [];
      _this.entries_eHrambaLog = [];
      _this.entries_CMISchangeLog = [];
      _this.entries_eHrambaLogOld = [];
      _this.entries_All = [];

      _this.allLogsIsLoading = true;
      _this.eHrambaLogIsLoading = true;
      _this.rmLogIsLoading = true;
      _this.CMISchangeLogIsLoading = true;
      _this.eHrambaLogOldIsLoading = true;

      _this.eHrambaLogTimeout = false;
      _this.rmLogTimeout = false;
      _this.CMISchangeLogTimeout = false;
      _this.eHrambaLogOldTimeout = false;

      _this.searchUrlParams = {
        limit: _this.limit,
        fromTime: _this.dateFrom ? _this.moment(_this.dateFrom, "YYYY-MM-DD HH:mm:ss").valueOf() : null,
        toTime: _this.dateTo ? _this.moment(_this.dateTo, "YYYY-MM-DD HH:mm:ss").valueOf() : null,
        user: _this.uporabnik ? _this.uporabnik.trim() : null,
        forward: false,
        verbose: true,
      };

      if (!_this.uporabnik) {
        delete _this.searchUrlParams.user;
      }


      await _this.getLogTimeData();

      axios
          .post((useOldApiEndpoint ? config.auditOld : config.audit) + "archeia", _this.getPostData(), {
            params: _this.searchUrlParams,
          })
          .then((res) => {
            console.log("RESPONSE ", res);
            _this.entries_eHrambaLog = res.data.entries;
            _this.eHrambaLogIsLoading = false;
            // _this.search_RM(useOldApiEndpoint);
          })
          .catch((error) => {
            if(error.response.status === 408) {
              _this.eHrambaLogTimeout = true;
            }

            console.error(error);
            _this.isLoading = false;
            _this.eHrambaLogIsLoading = false;
          });

      await _this.search_RM(useOldApiEndpoint).then(() => { _this.showLogs(); });
      await _this.search_CMISchangeLog(useOldApiEndpoint).then(() => { _this.showLogs(); });
      if(!useOldApiEndpoint) {
        await _this.search_eHrambaLogOld(useOldApiEndpoint).then(() => { _this.showLogs(); });
      }
      _this.allLogsIsLoading = false;

    },

    retrieveTypeOptions(useOldApiEndpoint) {
      const _this = this;

      axios
          .get(config.codeLists + "audit-dictionary")
          .then((res) => {
            _this.typeOptions = _.filter(res.data.body, item => item.type === 'event-node-type' && item.app === 'RM');
          })
          .catch((error) => {
            console.error(error);
          });
    },

    retrieveEventOptions() {
      const _this = this;

      axios
          .get(config.codeLists + "audit-dictionary")
          .then((res) => {
            _this.eventOptions = _.filter(res.data.body, function (item) {
              if (item.type === "action" || item.type === "event") {
                return item;
              }
            });
          })
          .catch((error) => {
            console.error(error);
          });
    },

    async search_RM(useOldApiEndpoint) {
      const _this = this;

      // _this.isLoading = true;

      await axios
          .post((useOldApiEndpoint ? config.auditOld : config.audit) + "RM", _this.getPostData(), {
            params: _this.searchUrlParams,
          })
          .then((res) => {
            console.log("RESPONSE ", res);
            _this.entries_RM = res.data.entries;
            _this.rmLogIsLoading = false;
            // _this.search_CMISchangeLog(useOldApiEndpoint);
          })
          .catch((error) => {
            if(error.response.status === 408) {
              _this.rmLogTimeout = true;
            }

            console.error(error);
            _this.isLoading = false;
            _this.rmLogIsLoading = false;
          });
    },

    async search_CMISchangeLog(useOldApiEndpoint) {
      const _this = this;

      // _this.isLoading = true;

      await axios
          .post((useOldApiEndpoint ? config.auditOld : config.audit) + "CMISChangeLog", _this.getPostData(), {
            params: _this.searchUrlParams,
          })
          .then((res) => {
            console.log("RESPONSE ", res);
            _this.entries_CMISchangeLog = res.data.entries;
            _this.CMISchangeLogIsLoading = false;

            if(useOldApiEndpoint) {
              //_this.showLogs();
            } else {
              // _this.search_eHrambaLogOld(useOldApiEndpoint);
            }
          })
          .catch((error) => {
            if(error.response.status === 408) {
              _this.CMISchangeLogTimeout = true;
            }

            console.error(error);
            _this.isLoading = false;
            _this.CMISchangeLogIsLoading = false;
          });
    },

    async search_eHrambaLogOld(useOldApiEndpoint) {
      const _this = this;

      // _this.isLoading = true;

      await axios.post((useOldApiEndpoint ? config.auditOld : config.audit) + "ehramba", _this.getPostData(), {
        params: _this.searchUrlParams,
      })
          .then((res) => {
            console.log("RESPONSE ", res);
            _this.entries_eHrambaLogOld = res.data.entries;
            _this.eHrambaLogOldIsLoading = false;
            // _this.showLogs();
          })
          .catch((error) => {
            if(error.response.status === 408) {
              _this.eHrambaLogOldTimeout = true;
            }

            console.error(error);
            console.error(error.response);
            console.error(error.response.status);
            _this.isLoading = false;
            _this.eHrambaLogOldIsLoading = false;
          });
    },

    showLogs() {
      const _this = this;

      _this.entries_All = _.concat(
          _this.entries_RM,
          _this.entries_eHrambaLog,
          _this.entries_CMISchangeLog,
          _this.entries_eHrambaLogOld
      );

      setTimeout(function () {
        _this.entries_All = _.orderBy(
            _this.entries_All,
            "entry.time",
            "asc"
        );

        _this.isLoading = false;
        _this.searchDone = true;
      }, 500);
    },

    getPostData() {
      const _this = this;
      let data = {};

      if (_this.uuid) {
        data.uuid = _this.uuid.trim();
      }

      if (_this.sodisce) {
        data.sodisce = _this.sodisce;
      }

      if (_this.opravilna_stevilka_zadeve) {
        data.stevilkaZadeve = _this.opravilna_stevilka_zadeve.trim();
      }

      if (_this.ehrambaUporabnik) {
        data.koncniUporabnik = _this.ehrambaUporabnik.trim();
      }

      if (_this.tip) {
        data.tip = _this.tip;
      }

      if (_this.dogodek) {
        data.dogodek = _this.dogodek;
      }

      if (_this.koncniUporabnikCert) {
        data.koncniUporabnik = _this.koncniUporabnikCert.trim();
      }

      return data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/AuditLog.vue